var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 25.3333H25.8333V6.66667H7.16667V25.3333H16.5V18.6667H13.8333V16H16.5V13.7947C16.5 12.012 16.6867 11.3653 17.0333 10.7133C17.3748 10.0682 17.9026 9.54092 18.548 9.2C19.0573 8.92667 19.6907 8.76267 20.7973 8.692C21.236 8.664 21.804 8.69867 22.5013 8.79867V11.332H21.8333C20.6107 11.332 20.1053 11.3893 19.804 11.5507C19.6242 11.6431 19.4778 11.7895 19.3853 11.9693C19.2253 12.2707 19.1667 12.5693 19.1667 13.7933V16H22.5L21.8333 18.6667H19.1667V25.3333ZM5.83333 4H27.1667C27.5203 4 27.8594 4.14048 28.1095 4.39052C28.3595 4.64057 28.5 4.97971 28.5 5.33333V26.6667C28.5 27.0203 28.3595 27.3594 28.1095 27.6095C27.8594 27.8595 27.5203 28 27.1667 28H5.83333C5.47971 28 5.14057 27.8595 4.89052 27.6095C4.64048 27.3594 4.5 27.0203 4.5 26.6667V5.33333C4.5 4.97971 4.64048 4.64057 4.89052 4.39052C5.14057 4.14048 5.47971 4 5.83333 4Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.362c798f83eb9e7af33df0b1550225db.svg";
export { ForwardRef as ReactComponent };